/**
 * An internal type to index the UnitPair tuple
 */
export enum Dir {
  ToOnset = 0,
  ToUnit = 1
}
/**
 * A pair of equivalent values in two different numerical types
 *
 * Has an untyped default value
 *
 * Internally just a typescript tuple, or fixe-sized array
 */

export type UnitPair<
  From extends number = number,
  To extends number = number,
  Repeat extends string = string
> = Readonly<[From, To, Repeat?]>;
/**
 * A sorted table of equivalent pair, that can be binary searched
 *
 * Has an untyped default value
 */

export type UnitTable<
  From extends number = number,
  To extends number = number,
  Repeat extends string = string
> = UnitPair<From, To, Repeat>[];
